import { useState } from "react";
import { toast } from "sonner";
import { Phone, Mail, Copy, Check, ArrowUpRight } from "lucide-react";
import { SITE } from "@/constants/site";
import { FadeUp, Eyebrow } from "@/components/Reveal";

export default function CTABanner() {
    const [copied, setCopied] = useState(false);

    const copyEmail = async () => {
        try {
            await navigator.clipboard.writeText(SITE.email);
            setCopied(true);
            toast.success("Email copied to clipboard");
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error("Could not copy — email us at " + SITE.email);
        }
    };

    return (
        <section className="bg-ink text-cream">
            <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-28 lg:px-12">
                <FadeUp>
                    <Eyebrow className="text-gold">
                        Let's get started
                    </Eyebrow>
                    <h2 className="mt-5 max-w-3xl font-serif text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                        Your books, blooming.{" "}
                        <span className="italic text-gold">Today.</span>
                    </h2>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-cream/70">
                        A free 20-minute intro call — no jargon, no judgment,
                        no obligation. Tell us where your business is and we'll
                        tell you honestly how we can help.
                    </p>
                </FadeUp>

                <FadeUp delay={0.15}>
                    <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                        <a
                            href={SITE.phoneHref}
                            data-testid="cta-call-phone"
                            className="group flex items-center justify-center gap-3 rounded-full bg-gold px-8 py-4 text-sm font-semibold text-ink transition-all hover:-translate-y-0.5 hover:bg-gold-deep hover:text-cream"
                        >
                            <Phone className="h-4 w-4" />
                            Call {SITE.phoneDisplay}
                            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </a>
                        <button
                            onClick={copyEmail}
                            data-testid="cta-copy-email"
                            className="flex items-center justify-center gap-3 rounded-full border border-cream/25 px-8 py-4 text-sm font-semibold text-cream transition-all hover:-translate-y-0.5 hover:border-gold hover:text-gold"
                        >
                            {copied ? (
                                <Check className="h-4 w-4" />
                            ) : (
                                <Mail className="h-4 w-4" />
                            )}
                            {SITE.email}
                            {copied ? (
                                <Check className="h-4 w-4" />
                            ) : (
                                <Copy className="h-4 w-4 opacity-60" />
                            )}
                        </button>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}
